import { render, staticRenderFns } from "./TagInfoDialog.vue?vue&type=template&id=00b693de&scoped=true"
import script from "./TagInfoDialog.vue?vue&type=script&lang=ts"
export * from "./TagInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./TagInfoDialog.vue?vue&type=style&index=0&id=00b693de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b693de",
  null
  
)

export default component.exports